import { render, staticRenderFns } from "./HotelsAdvancedDetailOffers.vue?vue&type=template&id=85e1781e&"
import script from "./HotelsAdvancedDetailOffers.vue?vue&type=script&lang=js&"
export * from "./HotelsAdvancedDetailOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports